module.exports = "/packs/media/images/dashboard-5086b330546d2c8acaec487d9b32fd48.png";